import _default from './Reveal';
export { _default as default };